(function ($) {

    var timeCounterInit = function () {


        /**
         * DateTime Counter
         */
        $('[data-time-counter]').each(function (i, el) {

            var counterExpiryDateTime = moment.tz(el.dataset.timeCounter, el.dataset.timeZone);
            $(el).countdown(counterExpiryDateTime.toDate()).on('update.countdown', function (event) {

                var format = el.dataset.timeFormat || '%-Hh : %Mm : %Ss';
                $(el).html(event.strftime(format));
            });
        });
    }

    if (window.TimeCounterInit === undefined) {
        window.TimeCounterInit = timeCounterInit;
    }

    window.TimeCounterInit();

})(jQuery);